import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components/lib/Image';
import className from './style.module.scss';

/**
 * TooltipButton :
 *  - Component renders a single button in ControlsTooltip
 */
export function TooltipButton(props) {
  const onClick = (event) => {
    event.stopPropagation();
    props.onClick();
  };

  const renderContent = () => {
    if (props.label) {
      return <p>{props.label}</p>;
    } else {
      return <Image src={props.image} alt={props.altText} />;
    }
  };
  return (
    <div className={className.controlsTooltip_item} onClick={onClick}>
      {renderContent()}
    </div>
  );
}

TooltipButton.propTypes = {
  /**
   * Label for button [ if passed in turns component to p tag else render img tag]
   */
  label: PropTypes.string,
  /**
   * Image to be displayed on the item
   */
  image: PropTypes.string,
  /**
   * Function to invoke when item is clicked
   */
  onClick: PropTypes.func,
};
